import React, { useEffect, useState } from "react";
import { getApplicationId, removeUserSession } from "../../api/common";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getAppUser, getNotification, markRead } from "../../api/api";
import { Link } from "react-router-dom";

const Navbar = (props) => {
  const [notification, setNotification] = useState([]);
  const [hold, setHold] = useState([]);
  const [c, setC] = useState([]);
  var i = 0;

  useEffect(() => {
    const userDetail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getAppUser().then(
        (result) => {
          if (result) {
            setHold(result.data);
          }
        },
        (error) => {
          toastr.error("Unable to Load User Data", "Error");
        }
      );

      /* eslint-disable no-unused-vars */
    };
    userDetail();

    const getNotifications = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getNotification().then(
        (result) => {
          // brandImage(result.data);
          if (result) {
            setNotification(result.data);
          }
        },
        (error) => {
          toastr.error("Unable to Load Data", "Error");
        }
      );
      /* eslint-disable no-unused-vars */
    };

    getNotifications();
    checkValueExist();
    /* eslint-disable no-unused-vars */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.name, c]);

  function formatTime(string) {
    var options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(string).toLocaleDateString([], options);
  }

  const markReads = async (person) => {
    /* eslint-disable no-unused-vars */
    // event.preventDefault();

    const result = await markRead(person).then(
      (result) => {
        // brandImage(result.data);
        setC(result.data);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
      }
    );

    /* eslint-disable no-unused-vars */
  };

  const checkValueExist = () => {
    var i = 0;
    var n = 0;
    notification.map((person, index) => {
      if (person.read === true) {
        i++;
      }
      n = index;
      return null;
    });
    // setHold(i);
    // setCount(n+1);
    return i;
  };

  const count = () => {
    // var i=0;
    var n = 0;
    notification.map((person, index) => {
      //     if(person.read === true)
      // {
      //     i++
      // }
      n = index;
      return null;
    });
    // setHold(i);
    // setCount(n+1);
    if (notification.length > 0) return n + 1;
    else return "No";
  };

  const handleLogout = (event) => {
    event.preventDefault();
    removeUserSession();
    window.location.href = "/login";
  };

  const pubNotification = (event) => {
    event.preventDefault();
    window.location.href = "/notification";
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="pushmenu"
            href="#!"
            onClick={(e) => e.preventDefault()}
            role="button"
          >
            <i className="fas fa-bars"></i>
          </a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <a href="/" className="nav-link">
            Home
          </a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <a href="#!" onClick={handleLogout} className="nav-link">
            Logout
          </a>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto">
        {(hold.superAdmin === true || hold.admin === true) && (
          <li className="nav-item dropdown">
            <a
              className="nav-link"
              data-toggle="dropdown"
              href="#!"
              onClick={(e) => e.preventDefault()}
            >
              <i className="far fa-bell"></i>

              {!(checkValueExist() === 0) && (
                <span className="badge badge-warning navbar-badge">
                  {checkValueExist()}
                </span>
              )}
            </a>
            <div
              className="dropdown-menu dropdown-menu-lg dropdown-menu-right"
              style={{ height: "400px", overflowY: "auto" }}
            >
              <span className="dropdown-header">
                {count() + " Notifications"}
              </span>
              {notification
                .sort((a, b) => (a.date > b.date ? -1 : 1))
                .map((person, index) => (
                  <div key={index}>
                    <div className="dropdown-divider"></div>
                    <Link
                      to={
                        person.redirect === "analytics"
                          ? "/analytics"
                          : person.redirect === "footer"
                            ? "/footer"
                            : person.redirect === "ticker"
                              ? "/tickers"
                              : person.redirect === "menu"
                                ? "/menu"
                                : person.redirect === "element" &&
                                    person.itemtype !== "tabItem" &&
                                    person.itemtype !== "textGrid" &&
                                    person.itemtype !== "highlightTextGrid"
                                  ? "/item/" +
                                    person.itemtype +
                                    "/" +
                                    person.itemid
                                  : (person.redirect === "element" &&
                                        person.itemtype === "textGrid") ||
                                      (person.redirect === "element" &&
                                        person.itemtype === "highlightTextGrid")
                                    ? "/" +
                                      person.itemtype +
                                      "/" +
                                      person.itemid
                                    : person.redirect === "element" &&
                                        person.itemtype === "tabItem"
                                      ? "/tab/" + person.itemid
                                      : person.redirect === "page" &&
                                          person.itemtype === "normalPage"
                                        ? "/page/" + person.itemid
                                        : "/" +
                                          (person.itemtype + "").toLowerCase() +
                                          "/" +
                                          person.itemid
                      }
                      //   onClick={markReads(person._id)}

                      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                      className="dropdown-item"
                    >
                      {/* <a href="#!" onClick={markReads(person)} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className="dropdown-item"> */}
                      <span onClick={(event) => markReads(person._id)}>
                        {person.read === false && (
                          <i className="fas fa-envelope-open mr-2"></i>
                        )}
                        {person.read === true && (
                          <i className="fas fa-envelope mr-2"></i>
                        )}{" "}
                        {person.message.substring(0, 25)}
                        {}
                        <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {person.message.substring(25)}
                      </span>
                      <span className="float-right text-muted text-sm">
                        {formatTime(person.date)}
                      </span>
                      {/* </a> */}
                    </Link>
                    <div className="dropdown-divider"></div>
                  </div>
                ))}
              {/* <a href="#!" onClick={e => e.preventDefault()} className="dropdown-item">
                        <i className="fas fa-users mr-2"></i> 8 friend requests
                        <span className="float-right text-muted text-sm">12 hours</span>
                    </a>
                    <div className="dropdown-divider"></div>
                    <a href="#!" onClick={e => e.preventDefault()} className="dropdown-item">
                        <i className="fas fa-file mr-2"></i> 3 new reports
                        <span className="float-right text-muted text-sm">2 days</span>
                    </a> */}
              {/* <div className="dropdown-divider"></div> */}
              <a
                href="#!"
                onClick={pubNotification}
                className="dropdown-item dropdown-footer"
              >
                See All Notifications
              </a>
            </div>
          </li>
        )}

        {/* <li className="nav-item">
          <a
            href={
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_PREV_DEV_URL +
                  getApplicationId() +
                  "/home"
                : process.env.REACT_APP_PREV_PROD_URL +
                  getApplicationId() +
                  "/home"
            }
            className="nav-link"
            role="button"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fas fa-expand-arrows-alt"></i>
          </a>
        </li> */}
        <li className="nav-item">
          <a
            className="nav-link"
            data-slide="true"
            href="#!"
            onClick={handleLogout}
            role="button"
          >
            <i className="fas fa-sign-out-alt"></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
